import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/axiosConfig"; // Global axios interceptor - must load before App
import App from "@/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
// StrictMode removido para evitar errores de DOM en móviles
// React 19 con StrictMode causa race conditions en reconciliación de DOM
root.render(<App />);

// Register service worker for PWA
serviceWorkerRegistration.register();
